import { NewCheckoutI } from "../../../../../api/request/Lead/Interfaces/DataInterface.response";

export const isMockPayment = (): boolean => {
  if (typeof window === "undefined") return false;
  // Hard block in production — preview/sandbox affordance must never reach real users.
  if (process.env.REACT_APP_ENVIROMENT === "PRD") return false;
  return new URLSearchParams(window.location.search).get("mock") === "1";
};

const today = new Date();
const effectDate = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000)
  .toISOString()
  .slice(0, 10);

export const paymentMockCheckout: NewCheckoutI = {
  name: "Mario",
  lastName: "Rossi",
  lastName2: "",
  email: "mario.rossi@example.it",
  gender: "M",
  zipcode: "00100",
  birthdate: "1985-04-12",
  phone: "+39 333 1234567",
  purchasePeriod: "monthly",
  period: "monthly",
  firstPayment: 0.5,
  regularPrice: 24,
  priceToPay: 20,
  finalYearlyPrice: 240,
  capital: 150000,
  promotionalCode: "",
  promoRemovable: false,
  coverage: "basic",
  intention: "family",
  promoConditions: "",
  isPromoted: false,
  feeCollection: [
    {
      frecuency: "MONTHLY",
      expectedPaymentDate: effectDate,
      total: 20,
      discountAmount: 0,
    },
  ],
};

export const paymentMockSetupIntent = {
  clientSecret: "mock_client_secret",
  status: "requires_payment_method",
};
